
import { defineComponent } from "vue";
import PageButtonsComponent from "@/components/PageButtons.component.vue";
import GeneratedAlertListComponent from "@/components/alerts/GeneratedAlertList.component.vue";
import securityService from "@/service/security.service";
import { AppType } from "@/types/app.type";
import { Action, ElMessage, ElMessageBox } from "element-plus";
import { Refresh } from "@element-plus/icons-vue";
import { deleteNotification, getNotifications } from "@/service/generatedAlert.service";
import { Filter } from "@/types/filter.type";
import { AlertNotification } from "@/types/notificationAlert.type";

import { getSamplingPointsList, getSamPointOnlyParameters } from "@/service/samplingpoint.service";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { Parameter } from "@/types/parameter.type";

export default defineComponent({
  components: {
    PageButtonsComponent,
    GeneratedAlertListComponent,
  },
  setup() {
    const isAppSupport = securityService.isApp(AppType.SUPPORT);
    const appIsSupportAndRoleIsSupport =
      (isAppSupport && securityService.canAccessToApp(AppType.SUPPORT)) ||
      securityService.canAccessToApp(AppType.ADMIN);
    const canSeepPoints = appIsSupportAndRoleIsSupport;

    const isAppStations = securityService.isApp(AppType.STATIONS);
    const appIsStationAndRoleIsStations =
      (isAppStations && securityService.canAccessToApp(AppType.STATIONS)) ||
      securityService.canAccessToApp(AppType.ADMIN);
    const canSeeStations = appIsStationAndRoleIsStations;

    return {
      canSeepPoints,
      canSeeStations,
      Refresh,
    };
  },
  data() {
    return {
      tipoSampling: "default" as string,
      tipoStation: "default" as string,
      seeType: "samplingPoint" as string,
      query: "" as string,
      queryHistory: undefined as number | undefined,
      searchQuery: "" as string,
      startDate: new Date(),
      endDate: new Date(),
      startDateFilter: undefined as string | undefined,
      endDateFilter: undefined as string | undefined,
      visibleDate: false,
      visibleSearch: false,
      selectedItems: [] as AlertNotification[],
      selectedAll: false as boolean,

      selectedSamplingPoint: undefined as number | undefined,
      selectedParameters: [],
      samplingPoints: [] as SamplingPoint[],
      parameters: [] as Parameter[],
    };
  },

  async mounted() {
    this.changeType();

    const idParam = this.$route.query.id;

    if (idParam) {
      try {
        const filter: Filter = {
          fields: {
            "alertNotification.alertId": {
              operator: "equal",
              value: idParam,
            },
          },
        };

        const alert = await getNotifications(1, 10, this.seeType, filter);

        this.query = alert.data[0].stationAlert?.name || "";
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error al obtener notificaciones:", error);
      }
    }
    const response = await getSamplingPointsList();
    this.samplingPoints = response.data;
  },
  methods: {
    updateSelectedItems(selectedItems: AlertNotification[]) {
      this.selectedItems = selectedItems;
    },
    // Seleccionar todas las alertas del la pagina
    selectAll() {
      this.selectedAll = !this.selectedAll;
      const generatedAlertListComponent = this.$refs["generatedAlertList"];
      if (generatedAlertListComponent) {
        (
          this.$refs["generatedAlertList"] as InstanceType<typeof GeneratedAlertListComponent>
        ).selectAllItems(this.selectedAll);
      }
    },
    // Actualizar la busqueda, notificaciones de {id} alerta
    async updateQuery(id: string) {
      try {
        const filter: Filter = {
          fields: {
            "alertNotification.id": {
              operator: "equal",
              value: id,
            },
          },
        };

        const alert = await getNotifications(1, 10, undefined, filter);
        this.query = "";
        this.queryHistory = Number(alert.data[0].alert?.id);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error al obtener notificaciones:", error);
      }
    },
    async serchAlertNotifications(id: number) {
      this.query = "";
      this.queryHistory = Number(id);
    },

    async deleteAlert() {
      // Borrar notificaciones seleccionadas
      if (this.selectedItems && this.selectedItems.length > 0) {
        ElMessageBox.confirm(this.$t("confirm.deleteGeneratedAlerts"), this.$t("label.warning"), {
          confirmButtonText: this.$t("btn.accept"),
          cancelButtonText: this.$t("btn.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
          callback: (action: Action) => {
            if (action === "confirm") {
              this.selectedItems.forEach((item) => {
                deleteNotification(item);
              });
              ElMessage.success(this.$t("success.action"));
              (
                this.$refs["generatedAlertList"] as InstanceType<typeof GeneratedAlertListComponent>
              ).refreshAlert(this.seeType);
              this.selectedAll = false;
            }
          },
        });
      }
    },
    redirectCreate() {
      if (this.$route.path.includes("admin")) {
        this.$router.push("/stations/alerts");
      } else if (this.$route.path.includes("stations")) {
        this.$router.push("/stations/alerts");
      } else {
        this.$router.push("/support/alerts?create=true");
      }
    },
    changeStation() {
      if (this.tipoStation != "primary") {
        this.tipoSampling = "default";
        this.tipoStation = "primary";
        (
          this.$refs["generatedAlertList"] as InstanceType<typeof GeneratedAlertListComponent>
        ).refreshAlert("station");
        this.seeType = "station";
      }
    },
    changeSamplingPoint() {
      if (this.tipoSampling != "primary") {
        this.tipoSampling = "primary";
        this.tipoStation = "default";
        (
          this.$refs["generatedAlertList"] as InstanceType<typeof GeneratedAlertListComponent>
        ).refreshAlert("samplingPoint");
        this.seeType = "samplingPoint";
      }
    },

    getTypeAdmin() {
      return;
    },

    changeType() {
      if (
        (this.canSeepPoints && !this.canSeeStations) ||
        (this.canSeepPoints && this.canSeeStations)
      ) {
        this.tipoSampling = "primary";
      }

      if (this.canSeeStations && !this.canSeepPoints) {
        this.tipoStation = "primary";
      }
      if (!this.canSeepPoints && this.canSeeStations) {
        this.seeType = "station";
        (
          this.$refs["generatedAlertList"] as InstanceType<typeof GeneratedAlertListComponent>
        ).refreshAlert("station");
      }
    },

    search(): void {
      // Buscador
      this.query = this.searchQuery;
      this.visibleSearch = false;
    },

    confirm() {
      if (this.startDate !== undefined && this.endDate !== undefined) {
        if (this.startDate > this.endDate) {
          ElMessage.error(this.$t("error.wrongDate"));
        } else {
          // this.startDateFilter = this.startDate.toISOString();
          // this.endDateFilter = this.endDate.toISOString();
          let startDate = this.startDate;
          let endDate = this.endDate;
          (
            this.$refs["generatedAlertList"] as InstanceType<typeof GeneratedAlertListComponent>
          ).refreshAlert(undefined, startDate, endDate);
        }
      }
    },

    disabledData(time: Date) {
      return time.getTime() > Date.now();
    },

    cancelSearch() {
      this.query = "";
      this.searchQuery = "";
      this.queryHistory = undefined;
      this.visibleSearch = false;
    },

    refresh() {
      this.cancelSearch();
      this.startDateFilter = undefined;
      this.endDateFilter = undefined;
      this.selectedSamplingPoint = undefined;
      this.selectedParameters = [];
      this.query = "";
    },
    async loadParameters() {
      if (this.selectedSamplingPoint) {
        this.parameters = await getSamPointOnlyParameters(this.selectedSamplingPoint);
      }
    },
  },
});
